import { createClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// detectSessionInUrl is intentionally false: Login.tsx exchanges the PKCE
// code explicitly so we have deterministic control over when the session is
// set and which mode the UI is in. Auto-detect made the PASSWORD_RECOVERY
// event racy against React mounting.
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
})
